import React from 'react';
import { connect } from 'react-redux';
import { ICreditNotesProps } from './CreditNotes.properties';
import { bindActionCreators, Dispatch } from 'redux';
import { selectors as uiSelectors, actions as uiActions } from 'ducks/ui';
import CreditNotes from './CreditNotes';
import CreditNotesStateProvider from './CreditNotes.context';
import { actions as operationActions } from 'ducks/uiOperations';
import { selectors as configSelectors } from 'ducks/appConfig';

const mapStateToProps = (state) => ({
    isMenuOptionOpen: uiSelectors.isMenuOptionOpen(state),
    isV2: configSelectors.isV2(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeValidationDialog: uiActions.changeValidationDialog,
        toggleMenuOption: uiActions.toggleMenuOption,
        changeOperationMode: operationActions.changeOperationMode,
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)((props: Readonly<
    ICreditNotesProps>) => {
    return (
        <CreditNotesStateProvider>
            <CreditNotes {...props} />
        </CreditNotesStateProvider>
    );
});
